import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n before the app
import i18n from 'i18next';
import AppRouter from './components/AppRouter';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Ensure zh is the default on first load if no stored language
try {
  const stored = localStorage.getItem('i18nextLng') || sessionStorage.getItem('i18nextLng');
  if (!stored) {
    i18n.changeLanguage('zh');
    localStorage.setItem('i18nextLng', 'zh');
  }
} catch (err) {
  i18n.changeLanguage('zh');
}
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
); 